// extracted by mini-css-extract-plugin
export var customBuild = "styles-module--customBuild--0fdcc";
export var customH2 = "styles-module--customH2--461ef";
export var customOr = "styles-module--customOr--5b9be";
export var tryOne = "styles-module--tryOne--b3b0b";